<div
    [class.pressed]="isPressed"
    [class.small]="small"
    [class.smaller]="smaller"
    [ngClass]="cssMediaService.deviceCss('togglebutton')"
>
    <div [class.clicked]="isClicked" class="inner">
        <img [alt]="tooltip" [src]="source" [title]="tooltip" height="32" width="32" />
        <label [hidden]="!cssMediaService.isDesktop">{{ title }}</label>
    </div>
</div>
